import { requestWrapper } from '@/utils/axiosInstance';

export default {
  async getAll(query) {
    return await requestWrapper(null, 'GET', '/requirements_texts', query);
  },
  async create(acc) {
    return await requestWrapper(null, 'POST', '/requirements_texts', null, acc);
  },
  async get(id) {
    return await requestWrapper(null, 'GET', `/requirements_texts/${id}`);
  },
  async update(acc) {
    return await requestWrapper(null, 'PUT', `/requirements_texts/${acc.id}`, null, acc);
  },
  async remove(id) {
    return await requestWrapper(null, 'DELETE', `/requirements_texts/${id}`);
  },

  async getLinks(query) {
    return await requestWrapper(null, 'GET', '/requirement_requirements_texts', query);
  },
  async sortAccordions(accs) {
    return await requestWrapper(null, 'PUT', '/requirement_requirements_texts', null, accs);
  },
  async removeLink(id) {
    return await requestWrapper(null, 'DELETE', `/requirement_requirements_texts/${id}`);
  },
};
